export default __webpack_public_path__ + "static/media/UAE.fa2ddf5c.svg";